"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryGetFromHandle = exports.isInactive = exports.flingPieceToGutter = exports.removeAndScorePiecesInHole = exports.isPuckInHole = exports.calcQuadrantEx = exports.removeAll0ScoringPucks = exports.removeAllPiecesThatMovedOrWereHit = exports.checkAllForMovement = exports.clearMovementFlags = exports.countNumOpponentHitPucks = exports.countNumOpponentScoringPucks = exports.calcIsOnCenterLineEx = exports.calcIsInCenterEx = exports.calcScoreForPuckEx = exports.calcIsInCenter = exports.calcScoreForPuck = exports.checkIsStill = exports.checkForAllStill = exports.renderAt = exports.render = exports.renderAll = exports.updatePhysicsTick = exports.killAll = exports.kill = exports.removeDead = exports.updateAllPhysicsTick = exports.create = exports.getById = exports.getAll = void 0;
var spritesPieces_1 = require("@crokinole/recyclers/spritesPieces");
var diveColors_1 = require("@dive/colors/diveColors");
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var crokinoleDefs_sidecar_1 = require("../main/crokinoleDefs-sidecar");
var crokinoleGameState_sidecar_1 = require("../main/crokinoleGameState-sidecar");
var crokinoleRenderer_sidecar_1 = require("../main/crokinoleRenderer-sidecar");
var physics_rapier_loader_sidecar_1 = require("../physics/physics_rapier_loader-sidecar");
var crokinoleSounds_sidecar_1 = require("../sound/crokinoleSounds-sidecar");
var crokinoleSimulationManager_sidecar_1 = require("@crokinole/main/crokinoleSimulationManager-sidecar");
var vectorUtils_sidecar_1 = require("@crokinole/to-engine/vectorUtils-sidecar");
var minigolfDefs_sidecar_1 = require("proto/minigolf/defs/minigolfDefs-sidecar");
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function getById(id) {
    for (var i = 0; i < objs.length; i++) {
        if (objs[i].id === id) {
            return objs[i];
        }
    }
    return null;
}
exports.getById = getById;
var create = function (x, y, player, id) {
    if (id === void 0) { id = 0; }
    var phys = physics_rapier_loader_sidecar_1.physics_rapier_loader.get();
    var puckRadius = crokinoleDefs_sidecar_1.crokinoleDefs.puckRadius, puckLinearDamping = crokinoleDefs_sidecar_1.crokinoleDefs.discLinearDamping, puckAngularDamping = crokinoleDefs_sidecar_1.crokinoleDefs.discAngularDamping, CollisionGroups = crokinoleDefs_sidecar_1.crokinoleDefs.CollisionGroups;
    // Create a dynamic rigid-body.
    var puck_rigidBodyDesc = phys.RA.RigidBodyDesc.dynamic()
        .setTranslation(x, y)
        .setCcdEnabled(true)
        .setLinearDamping(puckLinearDamping)
        .setAngularDamping(puckAngularDamping)
        .setCanSleep(false);
    var puck_rigidBody = phys.world.createRigidBody(puck_rigidBodyDesc);
    // Create a cuboid collider attached to the dynamic rigidBody.
    // const collisionEvents = 1 //     COLLISION_EVENTS = 1,
    var puck_colliderDesc = phys.RA.ColliderDesc.ball(puckRadius)
        .setRestitution(crokinoleDefs_sidecar_1.crokinoleDefs.discRestitution)
        .setFriction(crokinoleDefs_sidecar_1.crokinoleDefs.discFriction)
        // .setActiveEvents(collisionEvents)
        .setActiveEvents(phys.RA.ActiveEvents.COLLISION_EVENTS);
    //.setDensity(1 / 5)
    var puck_collider = phys.world.createCollider(puck_colliderDesc, puck_rigidBody);
    puck_collider.setCollisionGroups(CollisionGroups.playarea);
    if (!id) {
        id = crokinoleSimulationManager_sidecar_1.crokinoleSimulationManager.synced_createId();
    }
    // puck_rigidBody.setact
    var obj = {
        player: player,
        isOffBoard: false,
        isDiscarded: false,
        rigidBody: puck_rigidBody,
        isDead: false,
        eType: 'voy-misc',
        id: id,
        idLoaded: 0,
        // inHoleTimer: 0,
        movedThisTurn: false,
        wasHitThisTurn: false,
        // isInHole: false,
    };
    puck_rigidBody.userData = { type: 'puck', puck: obj };
    objs.push(obj);
    return obj;
};
exports.create = create;
var updateAllPhysicsTick = function () {
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        exports.updatePhysicsTick(puck);
    }
    exports.checkForAllStill();
    removeDead();
};
exports.updateAllPhysicsTick = updateAllPhysicsTick;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        var phys = physics_rapier_loader_sidecar_1.physics_rapier_loader.get();
        phys.world.removeRigidBody(c.rigidBody);
        // c.rigidBody = null as any
    });
}
exports.removeDead = removeDead;
var kill = function (puck) {
    puck.isDead = true;
};
exports.kill = kill;
var killAll = function () {
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        exports.kill(puck);
    }
};
exports.killAll = killAll;
var updatePhysicsTick = function (puck) {
    // TODO: see if we are moving?
    checkIfOffBoard(puck);
    addHoleGravity(puck);
};
exports.updatePhysicsTick = updatePhysicsTick;
var checkIfOffBoard = function (puck) {
    // See if our puck is off the table
    var body = puck.rigidBody;
    if (!puck.isOffBoard) {
        var posVec = body.translation();
        var posMag = vectorUtils_sidecar_1.vectorUtils.magnitude(posVec);
        if (posMag > (662 / 2 + 32 / 2) * crokinoleDefs_sidecar_1.crokinoleDefs.physicsMultiplier) {
            // puck.userData = 'off-table'
            puck.isOffBoard = true;
            // Set our collision group to only collide with the gutter
            body.collider(0).setCollisionGroups(crokinoleDefs_sidecar_1.crokinoleDefs.CollisionGroups.gutter);
        }
    }
};
var addHoleGravity = function (puck) {
    if (exports.isInactive(puck)) {
        // puck.inHoleTimer = 0
        return;
    }
    var body = puck.rigidBody;
    var phys = physics_rapier_loader_sidecar_1.physics_rapier_loader.get();
    var sensorPosition = phys.holeSensor.translation();
    var position = body.translation();
    var gravityDelta = {
        x: sensorPosition.x - position.x,
        y: sensorPosition.y - position.y,
    };
    var dist = vectorUtils_sidecar_1.vectorUtils.magnitude(gravityDelta);
    var holeGravity = crokinoleDefs_sidecar_1.crokinoleDefs.holeGravity;
    var holeGravityMaxDistance = crokinoleDefs_sidecar_1.crokinoleDefs.holeGravityMaxDistance;
    if (crokinoleDefs_sidecar_1.crokinoleDefs.debugSuperHoleGravity) {
        holeGravity *= 2;
        holeGravityMaxDistance *= 2;
    }
    if (dist > holeGravityMaxDistance) {
        // puck.inHoleTimer = 0
        return;
    }
    var mag = (holeGravityMaxDistance - dist) / holeGravityMaxDistance;
    if (dist < crokinoleDefs_sidecar_1.crokinoleDefs.innerHoleDistance) {
        // Reduce blackhole effect in middle
        mag *= 0.15;
        // Add impulse as drag
        var vel = body.linvel();
        var velMag = vectorUtils_sidecar_1.vectorUtils.magnitude(vel);
        if (velMag > 0.05) {
            var dragVel = vectorUtils_sidecar_1.vectorUtils.scale(vel, -1);
            dragVel = vectorUtils_sidecar_1.vectorUtils.normalize(dragVel);
            dragVel = vectorUtils_sidecar_1.vectorUtils.scale(dragVel, velMag * crokinoleDefs_sidecar_1.crokinoleDefs.holeDrag);
            body.applyImpulse(dragVel, true);
        }
        // puck.inHoleTimer += physics_rapier_loader.timestep
        // if (puck.inHoleTimer > 0.5) {
        // puck.player.numTokensInHole++
        // puck.isInHole = true
        // crokinoleGameState.get().lastPuckInHole = true
        // kill(puck)
        // }
    }
    else {
        // puck.inHoleTimer = 0
    }
    mag *= mag;
    var minMag = 0.01;
    if (mag < minMag) {
        mag = minMag;
    }
    // console.log(namespace, '1', gravityDelta)
    gravityDelta = vectorUtils_sidecar_1.vectorUtils.normalize(gravityDelta);
    gravityDelta = vectorUtils_sidecar_1.vectorUtils.scale(gravityDelta, mag);
    // console.log(namespace, '2', gravityDelta)
    body.applyImpulse({
        x: gravityDelta.x * holeGravity,
        y: gravityDelta.y * holeGravity,
    }, true);
};
var renderAll = function () {
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        exports.render(puck);
    }
};
exports.renderAll = renderAll;
var render = function (obj) {
    if (!obj.player) {
        return;
    }
    var pos = crokinoleRenderer_sidecar_1.crokinoleRenderer.getPhysicsPosition(obj.rigidBody);
    exports.renderAt(obj.player, pos.x, pos.y, pos.rotation, exports.isInactive(obj));
    if (!exports.isInactive(obj)) {
        diveFont_sidecar_1.diveFont.writeAbsolute(pos.x + 10, pos.y + 20, '' + exports.calcScoreForPuck(obj), 0.5, diveColors_1.diveColors.darkBlue);
    }
    if (crokinoleDefs_sidecar_1.crokinoleDefs.debugMp_showDiscIds) {
        diveFont_sidecar_1.diveFont.writeAbsolute(pos.x + 10, pos.y + 40, 'id' + obj.id, 0.5, diveColors_1.diveColors.darkBlue);
    }
};
exports.render = render;
var renderAt = function (player, x, y, rotation, ghost) {
    var scaling = 78 / 121;
    var sprite = spritesPieces_1.spritesPieces.getNext(x, y, sprites_sidecar_1.sprites.crokinoleDiscPlain[0]);
    sprite.tint = player.color;
    sprite.rotation = rotation;
    sprite.scale = sprite.scale * scaling;
    var spriteSymbol = null;
    if (player.symbol) {
        spriteSymbol = spritesPieces_1.spritesPieces.getNext(x, y, player.symbol);
        spriteSymbol.tint = player.color;
        if (player.symbolNoTint) {
            spriteSymbol.tint = diveColors_1.diveColors.pureWhite;
        }
        spriteSymbol.rotation = rotation;
        spriteSymbol.scale = spriteSymbol.scale * scaling * player.symbolScale;
    }
    if (ghost) {
        sprite.alpha = 0.75;
        if (spriteSymbol) {
            spriteSymbol.alpha = 0.75;
        }
    }
};
exports.renderAt = renderAt;
var checkForAllStill = function () {
    // TODO: move
    // let phys = physics_rapier_loader.get()
    var allStill = true;
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        if (!exports.checkIsStill(puck)) {
            allStill = false;
            break;
        }
    }
    if (allStill) {
        crokinoleGameState_sidecar_1.crokinoleGameState.get().allStillTime += physics_rapier_loader_sidecar_1.physics_rapier_loader.timestep;
    }
    else {
        crokinoleGameState_sidecar_1.crokinoleGameState.get().allStillTime = 0;
    }
    var combinedAllStill = (allStill &&
        crokinoleGameState_sidecar_1.crokinoleGameState.get().allStillTime > minigolfDefs_sidecar_1.minigolfDefs.allStillMaxTime) ||
        false;
    crokinoleGameState_sidecar_1.crokinoleGameState.get().isAllStill = combinedAllStill;
};
exports.checkForAllStill = checkForAllStill;
var checkIsStill = function (puck, tolerance) {
    if (tolerance === void 0) { tolerance = 0; }
    // let tolerance = 0.01
    if (!tolerance) {
        tolerance = crokinoleDefs_sidecar_1.crokinoleDefs.stillnessTolerance;
    }
    if (exports.isInactive(puck)) {
        return true;
    }
    var vel = puck.rigidBody.linvel();
    var velMag = vectorUtils_sidecar_1.vectorUtils.magnitude(vel);
    if (velMag > tolerance) {
        return false;
    }
    return true;
};
exports.checkIsStill = checkIsStill;
var calcScoreForPuck = function (puck) {
    if (exports.isInactive(puck)) {
        return 0;
    }
    if (exports.isPuckInHole(puck)) {
        return 20;
    }
    var pos = puck.rigidBody.translation();
    return exports.calcScoreForPuckEx(pos.x, pos.y);
};
exports.calcScoreForPuck = calcScoreForPuck;
var calcIsInCenter = function (puck) {
    if (exports.isInactive(puck)) {
        return false;
    }
    var pos = puck.rigidBody.translation();
    return exports.calcIsInCenterEx(pos.x, pos.y);
};
exports.calcIsInCenter = calcIsInCenter;
var calcScoreForPuckEx = function (x, y) {
    var pos = { x: x, y: y };
    var mag = vectorUtils_sidecar_1.vectorUtils.magnitude(pos);
    var score = 15;
    var adjust = -0.0;
    if (mag > (103 - 16 + adjust) * crokinoleDefs_sidecar_1.crokinoleDefs.physicsMultiplier) {
        score = 10;
    }
    if (mag > (206 - 16 + adjust) * crokinoleDefs_sidecar_1.crokinoleDefs.physicsMultiplier) {
        score = 5;
    }
    if (mag > (309 - 16 + adjust) * crokinoleDefs_sidecar_1.crokinoleDefs.physicsMultiplier) {
        score = 0;
    }
    return score;
};
exports.calcScoreForPuckEx = calcScoreForPuckEx;
var calcIsInCenterEx = function (x, y) {
    var pos = { x: x, y: y };
    var mag = vectorUtils_sidecar_1.vectorUtils.magnitude(pos);
    var adjust = -0.0;
    if (mag > (103 + 16 + adjust) * crokinoleDefs_sidecar_1.crokinoleDefs.physicsMultiplier) {
        return false;
    }
    return true;
};
exports.calcIsInCenterEx = calcIsInCenterEx;
var calcIsOnCenterLineEx = function (x, y) {
    var pos = { x: x, y: y };
    var mag = vectorUtils_sidecar_1.vectorUtils.magnitude(pos);
    var adjust = -0.0;
    if (mag < (309 - 16 + adjust) * crokinoleDefs_sidecar_1.crokinoleDefs.physicsMultiplier) {
        return false;
    }
    if (mag > (309 + 16 + adjust) * crokinoleDefs_sidecar_1.crokinoleDefs.physicsMultiplier) {
        return false;
    }
    return true;
};
exports.calcIsOnCenterLineEx = calcIsOnCenterLineEx;
var countNumOpponentScoringPucks = function (player) {
    var num = 0;
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        if (puck.player.color === player.color) {
            continue;
        }
        if (exports.calcScoreForPuck(puck) > 0) {
            num++;
        }
    }
    return num;
};
exports.countNumOpponentScoringPucks = countNumOpponentScoringPucks;
var countNumOpponentHitPucks = function (player) {
    var num = 0;
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        if (puck.player.color === player.color) {
            continue;
        }
        // if (puck.movedThisTurn || puck.wasHitThisTurn) {
        //   num++
        // }
        if (puck.wasHitThisTurn) {
            num++;
        }
    }
    return num;
};
exports.countNumOpponentHitPucks = countNumOpponentHitPucks;
var clearMovementFlags = function () {
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        puck.movedThisTurn = false;
        puck.wasHitThisTurn = false;
    }
};
exports.clearMovementFlags = clearMovementFlags;
var checkAllForMovement = function () {
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        if (!exports.checkIsStill(puck)) {
            puck.movedThisTurn = true;
        }
    }
};
exports.checkAllForMovement = checkAllForMovement;
var removeAllPiecesThatMovedOrWereHit = function (currentPlayer) {
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        if (exports.isInactive(puck)) {
            continue;
        }
        //if (puck.movedThisTurn || puck.wasHitThisTurn) {
        if (puck.wasHitThisTurn) {
            if (puck.player === currentPlayer) {
                exports.flingPieceToGutter(puck);
            }
        }
    }
};
exports.removeAllPiecesThatMovedOrWereHit = removeAllPiecesThatMovedOrWereHit;
var removeAll0ScoringPucks = function () {
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        if (exports.isInactive(puck)) {
            continue;
        }
        if (exports.calcScoreForPuck(puck) === 0) {
            exports.flingPieceToGutter(puck);
        }
    }
};
exports.removeAll0ScoringPucks = removeAll0ScoringPucks;
var calcQuadrantEx = function (x, y) {
    var pos = { x: x, y: y };
    var mag = vectorUtils_sidecar_1.vectorUtils.magnitude(pos);
    if (mag === 0) {
        return -1;
    }
    var angle = Math.atan2(y, -x);
    var turns = angle / (Math.PI * 2);
    if (turns < 0) {
        turns += 1;
    }
    if (turns > 1 / 8 && turns <= 3 / 8) {
        return 0;
    }
    if (turns > 3 / 8 && turns <= 5 / 8) {
        return 1;
    }
    if (turns > 5 / 8 && turns <= 7 / 8) {
        return 2;
    }
    if (turns > 7 / 8 || turns <= 9 / 8) {
        return 3;
    }
    return turns;
    //
    //  let quadrant = Math.floor((turns - 1 / 8) / 4)
    // return quadrant
};
exports.calcQuadrantEx = calcQuadrantEx;
var isPuckInHole = function (puck) {
    if (exports.isInactive(puck)) {
        return false;
    }
    var phys = physics_rapier_loader_sidecar_1.physics_rapier_loader.get();
    var holePosition = phys.holeSensor.translation();
    var puckPosition = puck.rigidBody.translation();
    var gravityDelta = {
        x: holePosition.x - puckPosition.x,
        y: holePosition.y - puckPosition.y,
    };
    var dist = vectorUtils_sidecar_1.vectorUtils.magnitude(gravityDelta);
    if (dist < crokinoleDefs_sidecar_1.crokinoleDefs.innerHoleDistance) {
        // Check our speed
        if (exports.checkIsStill(puck, crokinoleDefs_sidecar_1.crokinoleDefs.holeStillnessTolerance)) {
            return true;
        }
    }
    return false;
};
exports.isPuckInHole = isPuckInHole;
var removeAndScorePiecesInHole = function (player, doScoreForPlayer) {
    // let foundPiece = false
    var scored = false;
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        if (exports.isPuckInHole(puck)) {
            if (puck.player !== player) {
                // Opponents piece, score
                puck.player.numTokensInHole++;
                scored = true;
            }
            if (puck.player === player) {
                if (doScoreForPlayer) {
                    puck.player.numTokensInHole++;
                    scored = true;
                }
            }
            // TODO: move elsewhere
            if (scored) {
                exports.kill(puck); // TODO: show in special scoring area
            }
            else {
                exports.flingPieceToGutter(puck);
            }
        }
    }
    if (scored) {
        crokinoleSounds_sidecar_1.crokinoleSounds.playPieceInHole();
    }
};
exports.removeAndScorePiecesInHole = removeAndScorePiecesInHole;
var flingPieceToGutter = function (puck) {
    if (exports.isInactive(puck)) {
        return; // Already off board or dead
    }
    puck.isDiscarded = true;
    puck.rigidBody
        .collider(0)
        .setCollisionGroups(crokinoleDefs_sidecar_1.crokinoleDefs.CollisionGroups.inactive);
    var pos = puck.rigidBody.translation();
    var discardVec = vectorUtils_sidecar_1.vectorUtils.normalize(pos);
    discardVec = vectorUtils_sidecar_1.vectorUtils.scale(discardVec, 1);
    puck.rigidBody.applyImpulse(discardVec, true);
    // let toCenterVec =
};
exports.flingPieceToGutter = flingPieceToGutter;
var isInactive = function (puck) {
    return puck.isDead || puck.isOffBoard || puck.isDiscarded;
};
exports.isInactive = isInactive;
var tryGetFromHandle = function (handle) {
    for (var i = 0; i < objs.length; i++) {
        var puck = objs[i];
        if (puck.rigidBody.handle === handle) {
            return puck;
        }
        if (puck.rigidBody.collider(0).handle === handle) {
            return puck;
        }
    }
    return null;
};
exports.tryGetFromHandle = tryGetFromHandle;
